import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Offerings } from './components/Offerings';
import { Gallery } from './components/Gallery';
import { VideoFeature } from './components/VideoFeature';
import { Story } from './components/Story';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-full w-full bg-parchment font-body" data-id="element-0" data-mp="2rlyrsjjyuulm">
      <Header data-id="element-1" data-mp="2mlu5ue0ah7o0" />
      <main data-id="element-2" data-mp="2mmcd05ohp6ap">
        <Hero data-id="element-3" data-mp="2mmvkstkfeeb0" />
        <Offerings data-id="element-4" data-mp="2mn59mdtqiff4" />
        <Gallery data-id="element-5" data-mp="2mnne1xqjvzy4" />
        <VideoFeature data-id="element-6" data-mp="2mjzp7bw1w1pq" />
        <Story data-id="element-7" data-mp="31b8l22qjqjbb" />
        <Contact data-id="element-8" data-mp="31bs1tg4gn1nr" />
      </main>
      <Footer data-id="element-9" data-mp="31c1j8fbfw0hu" />
    </div>;
}